export default "__VITE_ASSET__CczMfSzb__"